module.exports = __webpack_public_path__ + "img/l-05.b21d933a.png";